import cookies from './lib/cookies'

(function() {
	window.cookies = cookies
	window.ageGatePassed = cookies.getCookie('AGE_CONFIRMED')

	document.addEventListener('DOMContentLoaded', () => {
		if (window.ageGatePassed) document.body.classList.add('age-confirmed')
	})

	if (navigator.userAgent.indexOf('Edge') != -1) window.browser = 'edge'
	else if (navigator.userAgent.indexOf('Chrome') != -1) window.browser = 'chrome'
	else if (navigator.userAgent.indexOf('Firefox') != -1) window.browser = 'firefox'
	else if (navigator.userAgent.indexOf('Safari') != -1) window.browser = 'safari'
	else if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) != -1) window.browser = 'opera'
	else window.browser = 'unknown'

	document.documentElement.classList.add('is-browser-' + window.browser)
})()
